import { render, staticRenderFns } from "./BaseInputSearch.vue?vue&type=template&id=84e2849c"
import script from "./BaseInputSearch.vue?vue&type=script&lang=js"
export * from "./BaseInputSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports